import { render, staticRenderFns } from "./PageLocations.vue?vue&type=template&id=2f33c8ca&"
import script from "./PageLocations.vue?vue&type=script&lang=js&"
export * from "./PageLocations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f33c8ca')) {
      api.createRecord('2f33c8ca', component.options)
    } else {
      api.reload('2f33c8ca', component.options)
    }
    module.hot.accept("./PageLocations.vue?vue&type=template&id=2f33c8ca&", function () {
      api.rerender('2f33c8ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/pages/PageLocations.vue"
export default component.exports